import dynamicWidgets from './enabled-widgets.js';

/**
 * @param {string} widgetName
 * @param {JQuery} $container
 */
export const initWidget = (widgetName, $container) => {

	try {
		const MpDynamicWidget = dynamicWidgets[widgetName];
		const { selector } = MpDynamicWidget.config;
		const $elements = $container.find(selector);

		// console.log('[%o] Found widgets [%o] for selector [%o]', MpDynamicWidget, $elements.length, selector);

		if ($elements.length === 0) {
			return;
		}

		// Enhance elements
		MpDynamicWidget.enhanceElements($elements);
	}
	catch (error) {
		console.error('Error loading widget [%o].\n%o', widgetName, error);
	}
};

/**
 * @param {JQuery} $container
 */
export const initDynamicWidgets = ($container) => {

	// Init dynamic widgets
	for (const widgetName of Object.keys(dynamicWidgets)) {
		initWidget(widgetName, $container);
	}
};